import { createContext, useContext } from "react";

export const RadioBtnContext = createContext();

export const useRadioBtn = () => useContext(RadioBtnContext);
